module.exports = __webpack_public_path__ + "img/06.598530a8.png";